import { parse as jsonParse, stringify as jsonStringify } from 'superjson'

export default class BaseObject {
  protected options: any

  protected relationKeys: string[]

  constructor (options: Partial<any> = {}, relationKeys: string[] = []) {
    this.options = options
    this.relationKeys = relationKeys
  }

  public withoutRelations () {
    const options: any = JSON.parse(JSON.stringify(this.options))

    this.relationKeys.forEach(key => {
      delete options[key]
    })

    this.options = options

    return this
  }

  public values (): any {
    return jsonParse<any>(jsonStringify(this.options))
  }
}
